/**
 * Haptic Feedback Utilities
 * Proporciona feedback táctil en dispositivos compatibles
 */

type HapticIntensity = 'light' | 'medium' | 'heavy'
type HapticPattern = 'success' | 'warning' | 'error'

class HapticsManager {
  private isSupported: boolean

  constructor() {
    // Verificar soporte de Vibration API
    this.isSupported = 'vibrate' in navigator
  }

  /**
   * Feedback de impacto simple
   */
  impact(intensity: HapticIntensity = 'medium'): void {
    if (!this.isSupported) return

    const durations = {
      light: 10,
      medium: 20,
      heavy: 40,
    }

    navigator.vibrate(durations[intensity])
  }

  /**
   * Feedback de selección (para botones, switches)
   */
  selection(): void {
    if (!this.isSupported) return
    navigator.vibrate(5)
  }

  /**
   * Patrones de feedback para notificaciones
   */
  notification(pattern: HapticPattern): void {
    if (!this.isSupported) return

    const patterns = {
      success: [10, 50, 10],
      warning: [20, 100, 20],
      error: [30, 100, 30, 100, 30],
    }

    navigator.vibrate(patterns[pattern])
  }

  /**
   * Patrón personalizado
   */
  custom(pattern: number | number[]): void {
    if (!this.isSupported) return
    navigator.vibrate(pattern)
  }

  /**
   * Detener vibración
   */
  stop(): void {
    if (!this.isSupported) return
    navigator.vibrate(0)
  }
}

export const haptics = new HapticsManager()
